<script setup lang="ts">
import { ArrowLeftIcon } from '@heroicons/vue/20/solid'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useEligibilitySubmissionStore } from '../Stores/eligibilitySubmission'

const router = useRouter()
const route = useRoute()

const eligibilitySubmissionStore = useEligibilitySubmissionStore()

const isBackVisible = computed(() => {
    if (route.name === 'home') {
        return route.query.entryToken || eligibilitySubmissionStore.campaignSwapPIScreen
    }

    return !['success', 'home'].includes(route.name as string)
})
</script>

<template>
    <div class="p-4">
        <button class="text-primary-800" type="button" @click="router.back()" v-if="isBackVisible">
            <ArrowLeftIcon class="size-4" />
        </button>
    </div>
</template>
